
import {Component, Input, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'ngx-validation-message-crud',
  styleUrls: ['./validation-message-crud.component.scss'],
  template: `
      <div class="warning" >
          <span class="caption status-danger" 
             *ngIf="showMinLength"> Mínimo {{ label }} la longitud es {{ minLength }} simbolos </span>
          <span class="caption status-danger mensaje"
             *ngIf="showMaxLength"> Maximo {{ label }} la longitud es {{ maxLength }} simbolos </span>
          <span class="caption status-danger mensaje" *ngIf="showPattern"> {{ label }} incorrecto  </span>
          <span class="caption status-danger mensaje" *ngIf="showRequired"> {{ label }} es requerido</span>
          <span class="caption status-danger mensaje" *ngIf="showMin"> Valor mínimo de {{ label }} es {{ min }}</span>
          <span class="caption status-danger mensaje" *ngIf="showMax"> Valor maximo de {{ label }} es {{ max }}</span>
          <span class="caption status-danger mensaje" *ngIf="validaCedula"> Ingrese una identificación válida </span>
          <span class="caption status-danger mensaje" *ngIf="fechaMayorValidator">La {{ label }} debe ser mayor o igual la fecha inicio</span>
          <span class="caption status-danger mensaje" *ngIf="extensionIncorrecta">La extensión de la imagen es incorrecto, asegurse que la extensión .jpg, .png</span>
          <span class="caption status-danger mensaje" *ngIf="sizeIncorrecta">El tamaño de la imagen debe ser menor o igual 1 kb</span>
          <span class="caption status-danger mensaje" *ngIf="timeInvalid">La {{ label }} debe se mayor a la hora de inicio </span>
          
          </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgxValidationMessageCrudComponent),
      multi: true,
    },
  ],
})
export class NgxValidationMessageCrudComponent {
  @Input()
  label: string = '';

  @Input()
  showRequired?: boolean;

  @Input()
  min?: number;

  @Input()
  showMin?: boolean;

  @Input()
  max?: number;

  @Input()
  showMax: boolean;

  @Input()
  minLength?: number;

  @Input()
  showMinLength?: boolean;

  @Input()
  maxLength?: number;

  @Input()
  showMaxLength?: boolean;

  @Input()
  showPattern?: boolean;
  @Input()
  validaCedula?: boolean;
  @Input()
  fechaMayorValidator?: boolean;
  @Input()
  extensionIncorrecta?: boolean;
  @Input()
  sizeIncorrecta?: boolean;
  @Input()
  timeInvalid?: boolean;
  
}
